'use client';

import throttle from 'lodash-es/throttle';
import { usePathname, useSearchParams } from 'next/navigation';
import { trackEvent } from '@kcd/event-tracker';

import type { FrequentlyOrderProduct } from '~/api/model';

/**
 * 상품 클릭/장바구니 추가 이벤트 추적 props (App Router 버전)
 *
 * Pages Router 의 `~/hooks/event` `useTrackProductEventProps` 를 이관한 것으로,
 * `next/router` 대신 `next/navigation` 의 `usePathname`/`useSearchParams` 를 사용한다.
 */
export const useTrackProductEventProps = (
  product: Partial<FrequentlyOrderProduct>,
  props?: Record<string, unknown>,
) => {
  const pathname = usePathname() ?? '';
  const searchParams = useSearchParams();
  const query = searchParams ? Object.fromEntries(searchParams.entries()) : {};

  return [
    {
      onClick: throttle(() => {
        trackEvent('clicked 캐시노트마켓 product', {
          productName: product.productName,
          product,
          pageName: pathname,
          query,
          path: pathname,
          ...props,
        });
      }),
    },
    {
      trackAddCart: throttle(() => {
        trackEvent('clicked 캐시노트마켓 product addCart', {
          productName: product.productName,
          product,
          pageName: pathname,
          query,
          path: pathname,
          ...props,
        });
      }),
    },
  ];
};
